export const wsConnect = host => ({ type: 'WS_CONNECT', host });
export const wsConnecting = host => ({ type: 'WS_CONNECTING', host });
export const wsConnected = host => ({ type: 'WS_CONNECTED', host });
export const wsDisconnect = host => ({ type: 'WS_DISCONNECT', host });
export const wsDisconnected = () => ({ type: 'WS_DISCONNECTED' });
export const receiveMessage = message => ({ type: 'RECEIVE_MESSAGE', message });
export const statusMessage = payload => ({ type: 'STATUS_MESSAGE', payload });
